export default __webpack_public_path__ + "static/media/Aetna.619b30f9.jpg";